import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { TooltipWrapper } from '../../formUtilities/useTooltip';
import { ChatTitle } from './chatConfig';

ChatLauncher.propTypes = {
	isOpen: PropTypes.bool,
	onToggle: PropTypes.func.isRequired,
};

export default function ChatLauncher({ isOpen, onToggle }) {
	// Titled so it stays distinct from the panel's own Close button.
	const label = `${isOpen ? 'Close' : 'Open'} ${ChatTitle}`;

	return (
		<TooltipWrapper
			text={label}
			child={
				<IconButton
					aria-label={label}
					aria-pressed={isOpen}
					onClick={onToggle}
					className="!text-white hover:!bg-white/20"
					sx={{
						width: 35,
						height: 35,
						backgroundColor: isOpen ? 'rgba(255,255,255,0.25)' : 'transparent',
					}}>
					<AutoAwesomeIcon sx={{ fontSize: 20 }} />
				</IconButton>
			}
		/>
	);
}
